import * as React from 'react';
export const SvgSoundQuiet = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M13.726 5.172a3.63 3.63 0 01-.033 5.67.813.813 0 01-1.094-.135l-.067-.067a.706.706 0 01.118-1.01 2.026 2.026 0 00.084-3.196.803.803 0 11.992-1.262zM9.193 1.727L5.011 4.994H2.964A.949.949 0 002 5.931v4.128a.949.949 0 00.964.937h2.047L9.21 14.27A1.11 1.11 0 0011 13.4V2.58a1.126 1.126 0 00-1.807-.853z' })));
};
export default SvgSoundQuiet;
